import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import parse from 'html-react-parser'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import { FiDownload } from 'react-icons/fi'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import { colors } from '../components/Colors'
import PageEye from '../components/PageEye'
import imgpartoagendado from '../img/parto-agendado.jpg'
import imgprontoatendimento from '../img/pronto-atendimento-internacao-b.jpg'
import imgprecadastromedico from '../img/pre-cadastro-medico.png'
import imgbuscandoajuda from '../img/buscando-ajuda-2.png'
import imgdoula from '../img/doula2.jpg'

import iconolhinho from '../icons/icon-olhinho.svg'
import iconcalendario from '../icons/icon-calendario.svg'
import icontermometro from '../icons/icon-termometro.svg'
import iconviamarela from '../icons/icon-viaamarela.svg'
import iconRg from '../icons/icon-rg.svg'
import iconcamisola from '../icons/icon-camisola.svg'
import iconmacacao from '../icons/icon-macacao.svg'
import iconevitar from '../icons/icon-evitar.svg'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import CentralAtendimento from '../components/CentralAtendimento'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  ul {
    margin-top: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    color: ${colors.cinza};
  }
  li {
    color: ${colors.cinza};
  }
  .link {
    color: #ffffff;
  }
  .inner {
    display: flex;
    div {
      width: 60%;
      padding-top: 40px;
      @media ${device.mobileL} {
        width: 100%;
        padding-right: 0px;
      }
    }
    h2 {
      color: #fff8d1;
    }
    img {
      max-height: 280px;
      @media ${device.mobileL} {
        padding: 0;
        width: 100%;
      }
    }
    @media ${device.mobileL} {
      display: block;
    }
  }

  .importante {
    p {
      padding: 0 2em 1.8em !important;
    }
  }
  .cuidados {
    display: flex;
    align-items: center;
    margin: 20px 0;
    background-color: #ffffff;
    overflow: hidden;
    box-shadow: 0px 31px 95px -40px rgba(0, 0, 0, 0.75);
    @media ${device.mobileL} {
      flex-wrap: wrap;
      max-height: 100%;
    }
    h3 {
      color: ${colors.lilas};
      position: relative;
      margin: 0;
      font-size: 1em;
      padding: 2em;
      :before {
        position: absolute;
        content: '';
        top: 24px;
        left: 38px;
        border: 1px solid ${colors.lilas};
        width: 5%;
        opacity: 0.5;
        @media ${device.mobileL} {
          left: 32px;
        }
      }
      :after {
        position: absolute;
        content: '';
        bottom: 24px;
        left: 38px;
        border: 1px solid ${colors.lilas};
        width: 5%;
        opacity: 0.5;
        @media ${device.mobileL} {
          left: 32px;
        }
      }
      @media ${device.mobileL} {
        padding: 2em 5px 2em 1.5em;
      }
    }
    div {
      height: 100%;
      @media ${device.mobileL} {
        order: 1;
        width: 100%;
      }
    }
    .fade {
      position: relative;
      padding: 0;
      :after {
        content: ' ';
        z-index: 10;
        display: block;
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        background-image: linear-gradient(
          to right,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 0)
        );
        @media ${device.mobileL} {
          background-image: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0)
          );
        }
      }
      @media ${device.mobileL} {
        order: 2;
        width: 100%;
      }
      img {
        display: block;
      }
    }
    .offset {
      @media ${device.mobileL} {
        margin-right: -160px;
      }
    }
    img {
      max-height: 319px;
      @media ${device.mobileL} {
        order: 2;
      }
      :nth-child(2) {
        max-height: 349px;
      }
    }
    p {
      color: #707070;
      padding: 2em 1.8em;
      @media ${device.mobileL} {
        padding: 1em;
      }
    }
    ul {
      @media ${device.mobileL} {
        padding: 2em;
      }
      li {
        @media ${device.mobileL} {
          color: #707070;
        }
      }
    }
    :nth-of-type(2) {
      .fade {
        :after {
          background-image: linear-gradient(
            to right,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 1)
          );
          @media ${device.mobileL} {
            background-image: linear-gradient(
              to bottom,
              rgba(255, 255, 255, 1),
              rgba(255, 255, 255, 0),
              rgba(255, 255, 255, 0)
            );
          }
        }
      }
    }
    @media ${device.mobileL} {
      justify-content: center;
    }
  }
  .estrutura {
    display: flex;
    div {
      width: 55%;
      padding-right: 120px;
      display: flex;
      flex-wrap: wrap;
      @media ${device.mobileL} {
        width: 100%;
        padding-right: 0px;
      }
    }
    img {
      width: 45%;
      @media ${device.mobileL} {
        width: 100%;
        margin-top: 2em;
      }
    }
    a {
      color: #539e9f;
      text-decoration: none;
    }
    @media ${device.mobileL} {
      display: block;
    }
  }
  .registro {
    background-color: #ffffff;
    padding: 20px 0;
    .cuidados {
      background-color: none;
      box-shadow: none;
      img {
        padding: 0 30px;
        @media ${device.mobileL} {
          order: 1;
        }
      }
      p {
        padding: 20px;
        color: ${colors.cinza};
        @media ${device.mobileL} {
          text-align: center;
          order: 2;
        }
      }
    }
  }
  .offsetImgEnd2 {
    padding-bottom: 20px;
  }
  .accordion__panel {
    div {
      p {
        color: #707070;
        padding: 30px;
      }
    }
    section {
      padding: 30px;
      p {
        color: #707070;
        padding: 0px;
      }
    }
  }
  .accordion__item {
    .cuidados {
      @media ${device.mobileL} {
        padding: 1em;
        div {
          order: 2;
        }
        img {
          order: 1;
        }
      }
    }
  }
  :nth-of-type(2) {
    background: ${colors.laranjaGradienteReverso};
    color: #ffffff;
    ul {
      padding: 2em 3em;
    }
  }
  :nth-of-type(3) {
    background: ${colors.verdeGradiente};
    padding: 0;
    color: #ffffff;
    margin-bottom: 70px;
    div {
      width: 70;
    }
    a {
      color: #ffffff;
    }
    .gatsby-image-wrapper {
      width: 30%;
      div {
        padding-bottom: 60% !important;
      }
    }
    @media ${device.mobileL} {
      padding: 0 2em;
      margin-bottom: 0px;
      img {
        width: auto;
        margin-bottom: -5px;
      }
    }
  }

  :nth-of-type(5) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
    h2 {
      color: #fff8d1;
    }
    a {
      color: #ffe17e;
      text-decoration: none;
    }
  }
  :nth-of-type(6) {
    h2 {
      color: ${colors.lilas};
    }
    h4 {
      color: #539e9f;
      padding-top: 30px;
    }
    .cuidados {
      align-items: start;
      margin-top: 0;
      img {
        padding: 30px 30px 0 50px;
        @media ${device.mobileL} {
          padding: 1em 0em;
        }
      }
      p {
        margin-bottom: 0;
        padding-bottom: 15px;
      }
    }
    @media ${device.mobileL} {
      padding-bottom: 0em;
    }
  }
  :nth-of-type(7) {
    background: ${colors.verdeGradiente};
    li {
      font-size: 0.9em;
      color: #ffffff;
    }
    h2 {
      color: #fff8d1;
    }
  }
  :nth-of-type(8) {
    h2 {
      color: ${colors.lilas};
    }
    p {
      padding-left: 0;
    }
    .cuidados {
      p {
        @media ${device.mobileL} {
          padding: 2em;
          order: 2;
        }
      }
      img {
        @media ${device.mobileL} {
          order: 1;
          padding: 2em 2em 0;
        }
      }
      :nth-of-type(2) {
        img {
          padding: 0 2em;
          @media ${device.mobileL} {
            padding: 2em 2em 0;
          }
        }
      }
    }
    img {
      padding: 0 30px;
      @media ${device.mobileL} {
        padding-bottom: 1em;
      }
    }
  }
  :nth-of-type(9) {
    background: ${colors.laranjaGradiente};
    h2 {
      color: #fff8d1;
    }
  }
  :nth-of-type(10) {
    h2 {
      color: ${colors.lilas};
    }
  }
  :nth-of-type(11) {
    background: ${colors.laranjaGradienteReverso};
    h2 {
      color: #fff8d1;
    }
    p {
      padding-top: 30px;
      color: #ffffff;
    }
    .accordion__panel {
      div {
        padding: 30px;
        p {
          color: #707070;
          padding: 0px;
        }
      }
    }
  }

  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }
  .direitos {
    a {
      width: 100%;
      max-width: 175px;
      height: 50px;
      text-align: center;
      flex-grow: 0;
      background-color: #ffffff;
      padding: 1em 2em;
      border-radius: 50px;
      text-transform: uppercase;
      font-size: 0.8em;
      text-decoration: none;
      color: #ff8f8c;
      opacity: 1;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      :hover {
        opacity: 0.8;
      }
      svg {
        color: #793939;
        margin-top: 5px;
      }
      @media ${device.mobileL} {
        margin: auto;
      }
    }
    ul {
      padding: 0;
      margin: 0;
      li {
        margin: 0 0 1.5em 0;
        padding: 0;
        list-style: none;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
        :last-child {
          margin: 0;
        }
        .linkHeader {
          background: #793939;
          padding: 0.5em 2em;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #ffffff;
          @media ${device.mobileL} {
            flex-wrap: wrap;
            padding: 2em;
            margin-bottom: 2em;
          }
          a {
            align-items: center;
          }
          h3 {
            font-size: 0.9em;
            position: relative;
            font-weight: normal;
            margin-top: 1em;
            :before {
              position: absolute;
              content: '';
              top: -10px;
              left: 0;
              border: 1px solid #a57777;
              width: 10%;
              @media ${device.mobileL} {
                left: 45%;
              }
            }
            :after {
              position: absolute;
              content: '';
              bottom: -10px;
              left: 0;
              border: 1px solid #a57777;
              width: 10%;
              @media ${device.mobileL} {
                left: 45%;
              }
            }
          }
        }
        .linkDescription {
          padding: 1em 3em;
          p {
            color: ${colors.cinza};
            font-size: 0.9em;
          }
        }
      }
    }
  }
`

export const GuiadeInternacaoParaGestantesTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'Para gestantes',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="cinza"
          height="180px"
          right="-17px"
          bottom="-10px"
          imgWidth="48%"
          overflow="visible"
          titleWidth="414px"
          imgInner
          mobileTop="-5%"
        />
        <GroupContent>
          <div className="center">{parse(sessoes[0].texto)}</div>
          <div className="center">
            <div className="cuidados importante">
              <div>
                <h3>{parse(sessoes[1].tituloDaSessao)}</h3>
                {parse(sessoes[1].texto)}
              </div>
              <section className="fade">
                <img
                  src={sessoes[1].imagemDaSessao.sourceUrl}
                  alt="Parto agendado"
                />
              </section>
            </div>
            <div className="cuidados importante">
              <section className="fade">
                <img
                  src={sessoes[2].imagemDaSessao.sourceUrl}
                  alt="Pronto atendimento"
                  className="offset"
                />
              </section>
              <div>
                <h3>{parse(sessoes[2].tituloDaSessao)}</h3>
                {parse(sessoes[2].texto)}
              </div>
            </div>
          </div>
          <div className="center">
            <Accordion allowZeroExpanded="true" allowMultipleExpanded="true">
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <h3>{parse(sessoes[3].acordeao[0].titulo)}</h3>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div>{parse(sessoes[3].acordeao[0].conteudo)}</div>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
            {parse(sessoes[4].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[5].tituloDaSessao)}</h2>
              {parse(sessoes[5].texto)}
            </div>
            <img
              src={sessoes[5].imagemDaSessao.sourceUrl}
              alt="Pré cadastro médico"
            />
          </div>
        </GroupContent>
        <PageEye
          color="lilas-vermelho"
          image={sessoes[6].imagemDaSessao.sourceUrl}
          right="30px"
          titleWidth="506px"
          overflow="visible"
          title={sessoes[6].tituloDaSessao}
          content={sessoes[6].texto}
        />
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[7].tituloDaSessao)}</h2>
            {parse(sessoes[7].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[8].tituloDaSessao)}</h2>
            <Accordion allowZeroExpanded="true" allowMultipleExpanded="true">
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <h3>{parse(sessoes[8].acordeao[0].titulo)}</h3>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="cuidados">
                    <img src={iconevitar} alt="Ultrassom" />
                    <div>{parse(sessoes[8].acordeao[0].conteudo)}</div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <h3>{parse(sessoes[9].acordeao[0].titulo)}</h3>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="cuidados">
                    <img src={iconcamisola} alt="Ultrassom" />
                    <div> {parse(sessoes[9].acordeao[0].conteudo)}</div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <h3>{parse(sessoes[10].acordeao[0].titulo)}</h3>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="cuidados">
                    <img src={iconmacacao} alt="Ultrassom" />
                    <div>{parse(sessoes[10].acordeao[0].conteudo)}</div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
            <h4>{parse(sessoes[11].tituloDaSessao)}</h4>
            {parse(sessoes[11].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[12].tituloDaSessao)}</h2>
            {parse(sessoes[12].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[13].tituloDaSessao)}</h2>
            {parse(sessoes[13].texto)}
            <div className="cuidados">
              <img src={iconolhinho} alt="Lembrancinhas" />
              {parse(sessoes[14].texto)}
            </div>
            <div className="cuidados">
              <img src={icontermometro} alt="Ultrassom" />
              {parse(sessoes[15].texto)}
            </div>
            <div className="cuidados">
              <img src={iconcalendario} alt="Ultrassom" />
              {parse(sessoes[16].texto)}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center direitos">
            <h2>{parse(sessoes[17].tituloDaSessao)}</h2>
            <ul>
              <li>
                <div className="linkHeader">
                  <h3>{parse(sessoes[17].linksExternos[0].titulo)}</h3>
                  <a
                    href={parse(sessoes[17].linksExternos[0].url)}
                    title=""
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                    <FiDownload />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="estrutura center">
            <div>
              <h2>{parse(sessoes[18].tituloDaSessao)}</h2>
              {parse(sessoes[18].texto)}
              <h2>{parse(sessoes[19].tituloDaSessao)}</h2>
              {parse(sessoes[19].texto)}
            </div>
            {sessoes[19].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[19].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Doula"
                className="offsetImgEnd2"
              />
            ) : (
              <img
                src={sessoes[19].imagemDaSessao.sourceUrl}
                alt="Doula"
                className="offsetImgEnd2"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[20].tituloDaSessao)}</h2>
            {parse(sessoes[20].texto)}
            <div className="registro">
              <div className="cuidados">
                <img src={iconviamarela} alt="Ultrassom" />
                {parse(sessoes[21].texto)}
              </div>
              <div className="cuidados">
                <img src={iconRg} alt="Ultrassom" />
                {parse(sessoes[22].texto)}
              </div>
            </div>
            {parse(sessoes[23].texto)}
            <div className="">
              <Accordion allowZeroExpanded="true" allowMultipleExpanded="true">
                {sessoes[24].acordeao.map((item, index) => (
                  <AccordionItem key={index}>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <h3>{parse(item.titulo)}</h3>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div>{parse(item.conteudo)}</div>
                    </AccordionItemPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </GroupContent>
        <CentralAtendimento />
      </Container>
    </>
  )
}

GuiadeInternacaoParaGestantesTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const GuiadeInternacaoParaGestantes = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <GuiadeInternacaoParaGestantesTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

GuiadeInternacaoParaGestantes.propTypes = {
  data: PropTypes.object.isRequired,
}

export default GuiadeInternacaoParaGestantes

export const GuiadeInternacaoParaGestantesQuery = graphql`
  query GuiadeInternacaoParaGestantesById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid(quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          acordeao {
            titulo
            conteudo
          }
          linksExternos {
            descricao
            titulo
            url
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
